import { Box, Button, TextField, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { useState } from "react";
import { GET_OTP, VERIFY_OTP } from "../../redux/apis";

import { useDispatch } from "react-redux";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import { getLoggedInUser } from "../../utilities/authUtils";
import "./login.css";
import { LoginComponent } from "../../components/login/loginComponent";

const Login = () => {
    return <>
        <Header />
        <Box
        
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            //minHeight="60vh"
            bgcolor="#f5f5f5"
            px={2}
            sx={{
                marginTop: 10, 
            }}
        >
            <LoginComponent isRedirect={true} />
        </Box>
        <Footer />
    </>
};

export default Login;